/**
 * Edge fades on horizontal rails.
 *
 * A static mask is the wrong tool: it dims the last item even when the row
 * fits, and it keeps dimming the left edge after you have scrolled back to the
 * start. This watches scroll position and marks only the side that is actually
 * cut, so the fade is information rather than decoration.
 *
 * Opt in with data-calmy-fade. Everything is a class toggle, so the mask itself
 * lives in CSS next to the component it belongs to.
 */
(function () {
  "use strict";

  function sync(el) {
    var max = el.scrollWidth - el.clientWidth;
    if (max < 8) {
      el.classList.remove("is-cut-start", "is-cut-end");
      return;
    }
    el.classList.toggle("is-cut-start", el.scrollLeft > 4);
    el.classList.toggle("is-cut-end", el.scrollLeft < max - 4);
  }

  function init(el) {
    if (el.__calmyFade) return;
    el.__calmyFade = true;

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; sync(el); });
    }
    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { sync(el); }, { passive: true });

    /* Card widths are not final until their images decode, so a rail measured
       at parse time can report no overflow and never get a fade. */
    window.addEventListener("load", function () { sync(el); });
    el.querySelectorAll("img").forEach(function (im) {
      if (!im.complete) im.addEventListener("load", function () { sync(el); }, { once: true });
    });

    sync(el);
  }

  function boot(root) { (root || document).querySelectorAll("[data-calmy-fade]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
